export { default as Github } from './github';
export { default as Coverage } from './coverages';
export { default as Npm } from './npm';